import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import html2canvas from 'html2canvas';
import { Accordion, AccordionTab } from "primereact/accordion";
import "./PM_TEMPLATE.css";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { PMTemplate } from "../../../services/Template/pm-template";
import { Api } from "../../../services/api";
import { InputNumber } from "primereact/inputnumber";
import { FaCopy } from 'react-icons/fa';
import { useScreenshot } from 'use-react-screenshot'

const VIEW_PM_TEMPLATE = ({ projectId, archiveId }) => {


  const ref = useRef(null)

  const [isLoading, setIsLoading] = useState(true);
  const [Section9Array, setSection9Array] = useState([{ name: '', }]);
  const [Section10Array, setSection10Array] = useState([{ name: '', }]);
  const [Section13Array, setSection13Array] = useState([{ name: '', }]);
  const [Section14Array, setSection14Array] = useState([{ name: '', }]);
  const [Section3Array, setSection3Array] = useState([{ name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', },]);

  const toast = useRef(null);

  const formik = useFormik({
    initialValues: PMTemplate.getFormName(),
    validate: (data) => {

    },


  });

  useEffect(() => {

    getTemplateDetails(archiveId);
    // getTemplateDetails(editId, 'pmId');

  }, []);

  const getTemplateDetails = (id, type) => {

    var url = Api.API_BASE_URL + 'all-template/get-archive-project-mangager/' + archiveId + '/' + projectId;

    fetch(url, {
      method: "GET",

    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);

        if (response.error != '') {
          formik.setFieldValue('PmTempleteId', 0);
          formik.setFieldValue('projectId', id);
          formik.setFieldValue('ProjectName', response.EstimatorProjectName);

        } else {
          formik.setFieldValue('PmTempleteId', response.pmTemplateId);
          PMTemplate.section_1_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_1[element]);
          });
          PMTemplate.section_2_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_2[element]);
          });
          PMTemplate.section_3_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_3[element]);
          });
          PMTemplate.section_4_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_4[element]);
          });
          PMTemplate.section_5_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_5[element]);
          });
          if (response.pm_section_6.length != 0) {
            formik.setFieldValue(`section_6`, response.pm_section_6);
          }


          if (response.pm_section_3_new.length != 0) {
            formik.setFieldValue(`section_3`, response.pm_section_3_new);
            setSection3Array(response.pm_section_3_new);
          }


          PMTemplate.section_7_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_7[element]);
          });
          PMTemplate.section_8_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_8[element]);
          });

          formik.setFieldValue(`section_9`, response.pm_section_9);
          setSection9Array(response.pm_section_9);
          formik.setFieldValue(`section_10`, response.pm_section_10);
          setSection10Array(response.pm_section_10);
          PMTemplate.section_11_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_11[element]);
          });
          PMTemplate.section_12_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_12[element]);
          });



          formik.setFieldValue(`section_13`, response.pm_section_13);
          setSection13Array(response.pm_section_13);
          formik.setFieldValue(`section_14`, response.pm_section_14);
          setSection14Array(response.pm_section_14);
          PMTemplate.section_15_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_15[element]);
          });
          PMTemplate.section_16_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_16[element]);
          });
          PMTemplate.section_17_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_17[element]);
          });
          PMTemplate.section_18_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_18[element]);
          });
        }

        setIsLoading(false);

      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
  }

  //? -----------------------
  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
    fontSize: "18px",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    // backgroundColor:'white'
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    backgroundColor: 'white',
    paddingTop: '5px'
  };

  const borderStyle = {
    // border: "1px solid #E9ECEF",
    // borderLeft: "2px solid #E9ECEF",
  };

  const yesCellStyle = {
    ...cellStyle,
    // background: "#FEC025",
  };

  const firstColumnWidth = {
    width: "80px",
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
  };

  //? -----------------------

  const renderTextArea = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      rows={maxLine}
      value={formik.values[fieldName]}
      disabled={true}
      onChange={(e) => {

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
    >{formData}</textarea>
  );

  const renderInputArea = (fieldName, placeholder, type = 'text', fromData = '') => (
    <input
      type={type}
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      value={fromData != '' ? fromData : formik.values[fieldName]}
      disabled={true}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);

        if (fieldName === 'sitePrep_P_B_C_Date') {

          formik.setFieldValue('scheduleConstructionStartDate', e.target.value);
        }
        if (fieldName === 'turnOver_C_F_C_Date') {
          formik.setFieldValue('scheduleProjectCompletion', e.target.value);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: '100%',
        height: '40px',
        boxSizing: 'border-box',
        border: 'none',
        fontSize: '16px',
        textAlign: 'center',
        marginTop: '0px',
      }}
    />
  );

  const renderInputAreaForAmount = (fieldName, formData = '') => (
    <InputNumber
      inputId="currency-us"
      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center"
      inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
      placeholder="$0.00"
      onChange={(e) => formik.setFieldValue(fieldName, e.value)}
      disabled={true}
      mode="currency"
      currency="USD"
      locale="en-US"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        fontSize: "16px",
        textAlign: "center !important",
        marginTop: "0px",
        outline: 'none',
      }}
    />
  );


  const renderInputAreaForHour = (fieldName, formData = '') => (
    <InputNumber
      inputClassName="is-positive"
      value={formData != '' ? formData : formik.values[fieldName]}
      disabled={true}
      onChange={(e) => formik.setFieldValue(fieldName, e.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        fontSize: "16px",
        textAlign: "center",
        marginTop: "0px",
      }}
    />
  );

  const renderPercentageInputArea = (fieldName, formData = '') => (
    <InputNumber

      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center"
      inputClassName={Number(formik.values[fieldName]) < 0 ? "is-negative" : "is-positive"}
      placeholder="0.00"
      maxFractionDigits={2}
      onChange={(e) => formik.setFieldValue(fieldName, e.value)}
      disabled={true}
      suffix="%"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        fontSize: "16px",
        textAlign: "center !important",
        marginTop: "0px",
      }}
    />
  );

  //! ----------------------------------------------------------

  const renderSelect = (fieldName, formData = '') => (
    <select
      name={fieldName}
      id={fieldName}
      value={(formData != '') ? formData : formik.values[fieldName]}
      className={'select-text-color-' + formik.values[fieldName]}
      onChange={(e) => {


        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', fontSize:'16px',color:'white', backgroundColor: '#ff0000', border: 'none' }}>
      <option value="NO">No</option>
      <option value="YES">Yes</option>
      <option value="NA">N/A</option>

    </select>
  );

  const renderSelect1 = (fieldName, formData = '') => {
    console.log('formData', formData);
   var val = (formData != '') ? formData : formik.values[fieldName];
    console.log('val', val);

    return <select
      name={fieldName}
      id={fieldName}
      value={(formData != '') ? formData : formik.values[fieldName]}
      className={'select-text-color-' + val}
      onChange={(e) => {

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', fontSize:'16px',color:'white', backgroundColor: '#ff0000', border: 'none' }}>
      <option value="NO">No</option>
      <option value="YES">Yes</option>
    </select>
  };



  const renderSelectForSection5 = (fieldName, placeholder, options, formData = '') => (
    <select
      name={fieldName}
      id={fieldName}
      value={(formData != '') ? formData : formik.values[fieldName]}
      disabled={true}
      onChange={(e) => {


        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', fontSize: '16px', border: 'none' }}>
      {options.map((option) => (
        <option value={option.id}>{option.name}</option>
      ))}

    </select>
  );

  const renderSelectForCostPerSF = (fieldName) => (
    <select
      name={fieldName}
      id={fieldName}
      value={formik.values[fieldName]}
      onChange={(e) => {


        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', fontSize: '16px', height: '32px', backgroundColor: '#F8EED7', color: '#495057', border: '1px solid #DDDFE2', borderRight: 'none' }}>
      <option value="Custom Home with Basement">Custom Home with Basement</option>
      <option value="Custom Home Slab on Grade">Custom Home Slab on Grade</option>
      <option value="Custom Home Crawl">Custom Home Crawl</option>
      <option value="Town House">Town House</option>
      <option value="Condo Above Ground">Condo Above Ground</option>
      <option value="Condo 1 Level Underground">Condo 1 Level Underground</option>
      <option value="Addition">Addition</option>
      <option value="Whole home gut">Whole home gut</option>
      <option value="Tenent Improvement">Tenent Improvement</option>
      <option value="Commerical Build">Commerical Build</option>
      <option value="Renovation">Renovation</option>
    </select>
  );

  const priceBodyTemplatee = (rowData) => {
    if (rowData === '') {
      return '';
    }
    let numberValue = Number(rowData);
    // Ensure rowData is a number after the conversion and it's not NaN
    if (isNaN(numberValue)) {

      return '';
    }

    const isNegative = rowData < 0; // Check if the value is negative

    return <span style={{ color: isNegative ? "red" : "black" }}>
      {formatCurrency(rowData)}

    </span>
  };

  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };



  //! ----------------------------------------------------------

  const section_1_Body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, placeholder) => {
    return (<tr>
      <td style={{ ...cellStyle, ...firstColumnWidth }} >
        {title}
      </td>


      <td style={{ borderStyle, cellStyleW, backgroundColor: 'white' }}>
        <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
          {renderSelect(fieldName_1)}
        </td>

        <td style={{ ...cellStyleW, width: '100%' }}>
          {renderTextArea(fieldName_2, placeholder)}
        </td>

      </td>

      <td style={{ borderStyle, cellStyleW, backgroundColor: 'white' }}>
        <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
          {renderSelect(fieldName_3)}
        </td>
        <td style={{ ...cellStyleW, width: '100%' }}>
          {renderTextArea(fieldName_4, placeholder)}
        </td>
      </td>

    </tr>);
  }

  const section_2_Body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5, fieldName_6) => {
    return (<tr>
      <td style={cellStyle}>{title}</td>
      <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
        {renderSelect(fieldName_1)}
      </td>

      <td style={cellStyle}>
        {renderInputArea(fieldName_2, '', 'date')}
      </td>

      <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
        {renderSelect(fieldName_3)}
      </td>

      <td style={cellStyleW}>
        {renderTextArea(fieldName_4, '')}
      </td>

      <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
        {renderSelect(fieldName_5)}
      </td>

      <td style={cellStyleW}>
        {renderTextArea(fieldName_6, '')}
      </td>

    </tr>
    );
  }



  const section_5_Body = (title, title2, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    return (
      <tr>
        <td style={cellStyle}>{title}</td>
        <td style={{ ...cellStyleW, }}>{renderInputAreaForAmount(fieldName_1)}</td>
        <td style={cellStyleW}>{renderInputAreaForAmount(fieldName_2)}</td>
        <td style={{ ...cellStyle, textAlign: 'center' }}>
          {priceBodyTemplatee(formik.values[fieldName_1] - formik.values[fieldName_2])}
        </td>
        <td style={cellStyle}>  {renderTextArea(fieldName_5, '')}	</td>
        <td style={cellStyleW}>
          {renderTextArea(fieldName_4, '')}
        </td>

      </tr>
    );

  }

  const section_8_Body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {

    return (
      <tr>
        <td style={cellStyle}>{title}</td>
        <td style={cellStyleW}>{renderInputArea(fieldName_1, '', 'date')}</td>
        <td style={cellStyleW}>{renderInputArea(fieldName_2, '', 'date')}</td>
        <td style={cellStyleW}>{renderInputArea(fieldName_3, '', 'date')}</td>

        <td style={cellStyleW}>
          {renderTextArea(fieldName_4, '')}
        </td>

      </tr>

    );

  }

  const section_11_Body = (title, fieldName_1, fieldName_2) => {
    return (
      <tr>
        <td style={cellStyle}>{title}</td>
        <td style={{ ...cellStyle, textAlign: 'center' }}>{fieldName_1 == "jobRunningTotal" ? getJobRunningTotal() : fieldName_1 == "balance" ? getBalaceTotal() : renderInputAreaForAmount(fieldName_1)}</td>

      </tr>


    );

  }
  const getBalaceTotal = () => {

    var total = Number(formik.values.amountPaid) + Number(formik.values.gst);

    var formattedTotal2 = total.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    //formik.setFieldValue('jobRunningTotal', total);
    return <strong>{formattedTotal2}</strong>;

  }

  const getJobRunningTotal = () => {

    var total = Number(formik.values.contractPriceAmount) + Number(formik.values.approvedChangeOrderPrice) + Number(formik.values.allowanceDiffrence);

    var formattedTotal = total.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    //formik.setFieldValue('jobRunningTotal', total);
    return <strong>{formattedTotal}</strong>;

  }


  //* -------------------------
  const copyImageToClipboard = (blob) => {
    // Check if Clipboard API is available
    if (navigator.clipboard && navigator.clipboard.write) {
      navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob
        })
      ]).then(() => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
        console.log('Image copied to clipboard');
      }).catch((error) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
        console.error('Error copying image to clipboard:', error);
      });
    } else {
      console.error('Clipboard API not available');
    }
  };
  const elementRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    // Add more refs for additional elements as needed
  ];
  const takeScreenshotAndCopy = async () => {
    console.log('Take screenshot and copy to clipboard');
    console.log('Take screenshot and copy to clipboard', ref.current);

    try {
      const canvasPromises = elementRefs.map(async (ref) => {
        if (ref.current) {
          return await html2canvas(ref.current);
        }
        return null;
      });

      const canvases = await Promise.all(canvasPromises);

      // Calculate total height of combined screenshots
      const totalHeight = canvases.reduce((acc, canvas) => acc + canvas.height, 0);

      // Create a new canvas to combine screenshots
      const combinedCanvas = document.createElement('canvas');
      combinedCanvas.width = Math.max(...canvases.map(canvas => canvas.width));
      combinedCanvas.height = totalHeight;

      // Draw screenshots onto the combined canvas
      const context = combinedCanvas.getContext('2d');
      let offsetY = 0;
      canvases.forEach(canvas => {
        context.drawImage(canvas, 0, offsetY);
        offsetY += canvas.height;
      });

      // Convert the combined canvas to a data URL
      const imageDataURL = combinedCanvas.toBlob(blob => {
        if (blob) {
          // Copy blob to clipboard
          copyImageToClipboard(blob);
        } else {
          console.error('Error creating blob');
        }
      }, 'image/png');
      // const imageDataURL = combinedCanvas.toDataURL();

      // Do something with the data URL (e.g., display it, save it, etc.)
      console.log('Combined screenshot data URL:', imageDataURL);
    } catch (error) {
      console.error('Error taking screenshots:', error);
    }

  };
  //* -------------------------


  return (
    <>


      <Toast ref={toast} />
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (


        <form onSubmit={formik.handleSubmit} className="pm-template-form">
          {/* <div className="flex justify-content-end submitbutton top-button" >
            <Button className="m-2 mx-4 p-2 px-3 " severity="Secondary" type="button"  title="Copy Client Weekly Update" onClick={takeScreenshotAndCopy}>
            <strong className="mr-2">Copy weekly update</strong>
              <FaCopy />
            </Button>

            <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center" severity="success" type="submit">
              <strong className="mr-2">Save</strong>
              <i className="pi pi-save"></i>
            </Button>

          </div> */}



<div className="cardd" style={{  border: 'none', }} >
            <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]} >

              {/* Section 1 */}
              <AccordionTab header="ACTION STEPS" className="mt-2">

                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }} >
                          ACTION STEPS
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          PM COMMENTS
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th>
                      </tr>
                    </thead>

                    <tbody>


                      <tr>
                        <td style={cellStyle} >
                          Target GP% CH 20% Reno 30%
                        </td>
                        <td style={cellStyleW} >
                          {renderTextArea('targetGp', '')}
                        </td>
                        <td style={cellStyleW} >
                          {renderTextArea('targetGpVpComments', '')}
                        </td>
                      </tr>

                      <tr>
                        <td style={cellStyle} >
                          Percentage Completion?
                        </td>
                        <td style={cellStyleW} >
                          {renderTextArea('percentageCompletion', '')}
                        </td>
                        <td style={cellStyleW} > {renderTextArea('percentageCompletionGpVpComments', '')}</td>
                      </tr>

                      <tr>
                        <td style={{ ...cellStyle, alignItems: 'center' }} >
                          <div style={{ ...cellStyle, border: 'none', display: 'flex' }}>
                            <span style={{ flex: '0 0 auto', paddingTop: '6px' }}>Cost Per SF</span>
                            <div style={{ flex: '1', marginLeft: '45px', width: '50%' }}>
                              {renderSelectForCostPerSF('costPerSF')}
                            </div>
                          </div>

                        </td>
                        <td style={{ ...cellStyleW, display: 'flex', alignItems: 'center' }} >


                          <div style={{ flex: '0 0 35%', borderRight: '2px solid #DDDFE2', }}>
                            {renderInputAreaForAmount('costPerSFAmount')}
                          </div>
                          <div style={{ flex: '0 0 65%', paddingTop: '5px' }}>
                            {renderTextArea('costPerSFComments', 'comments')}
                          </div>
                        </td>
                        <td style={cellStyleW} > {renderTextArea('costPerSFVpComments', '')}</td>
                      </tr>
                      {section_1_Body('Proj. on Schedule?', 'projectOnSchedule_PM', 'projectOnSchedule_PMReason', 'projectOnSchedule_VPC', 'projectOnSchedule_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('Trade partners advised of schedule 2M, 1M, 1W, 3D, 1D before they/material required on site?', 'tradePartnerAdvised_PM', 'tradePartnerAdvised_PMReason', 'tradePartnerAdvised_VPC', 'tradePartnerAdvised_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('All City and Engineering Inspections Completed and uploaded to BT?', 'allCityAndEngineersInspection_PM', 'allCityAndEngineersInspection_PMReason', 'allCityAndEngineersInspection_VPC', 'allCityAndEngineersInspection_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Proj. on budget?', 'projectOnBudget_PM', 'projectOnBudget_PMReason', 'projectOnBudget_VPC', 'projectOnBudget_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Proj. baseline set at excavation and project meeting baseline?', 'projectBaseLineSetExecution_PM', 'projectBaseLineSetExecution_PMReason', 'projectBaseLineSetExecution_VPC', 'projectBaseLineSetExecution_VPCReason', 'Reason? (If no) How do we get back on schedule?')}

                      {section_1_Body('Any Errors & Deficiencies?', 'anyErrorAndDeficiencies_PM', 'anyErrorAndDeficiencies_PMReason', 'anyErrorAndDeficiencies_VPC', 'anyErrorAndDeficiencies_VPCReason', 'Reason? (If no) How do we get back on schedule?')}

                      {section_1_Body('LIDA Labour in BT consistent with % of project completion', 'LidaLabourInBTConsistent_PM', 'LidaLabourInBTConsistent_PMReason', 'LidaLabourInBTConsistent_VPC', 'LidaLabourInBTConsistent_VPCReason', 'Reason? (If Yes, must enter into Ninety)')}


                      {section_1_Body('PM Contractor & Material BT TODO\'s upto date?', 'pmContructorAndMaterialBT_PM', 'pmContructorAndMaterialBT_PMReason', 'pmContructorAndMaterialBT_VPC', 'pmContructorAndMaterialBT_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Weekly PM/Client Update done?', 'weeklyPMClientUpdateDone_PM', 'weeklyPMClientUpdateDone_PMReason', 'weeklyPMClientUpdateDone_VPC', 'weeklyPMClientUpdateDone_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Have all Trade/Materials been inspected for QA & against the plans, specs, & drawings', 'haveAllTradeMaterialBeenInspected_PM', 'haveAllTradeMaterialBeenInspected_PMReason', 'haveAllTradeMaterialBeenInspected_VPC', 'haveAllTradeMaterialBeenInspected_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('PM QC BT TODO\'s Upto date?', 'pmQCVTTodoUptoDate_PM', 'pmQCVTTodoUptoDate_PMReason', 'pmQCVTTodoUptoDate_VPC', 'pmQCVTTodoUptoDate_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('PO/Sub Agreements upto date?', 'poSubAggreementUptoDate_PM', 'poSubAggreementUptoDate_PMReason', 'poSubAggreementUptoDate_VPC', 'poSubAggreementUptoDate_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Is client happy?', 'isClientHappy_PM', 'isClientHappy_PMReason', 'isClientHappy_VPC', 'isClientHappy_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('Risk/Safety/Client/Team?', 'riskSafetyClientTeam_PM', 'riskSafetyClientTeam_PMReason', 'riskSafetyClientTeam_VPC', 'riskSafetyClientTeam_VPCReason', 'Reason? (If no)')}


                    </tbody>
                  </table>
                </div>

              </AccordionTab>

              {/* Section 2 */}
              <AccordionTab header="Inspections Required" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Inspections Required
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Done: Yes/No or N/A
                        </th>
                        <th style={{ ...headerStyle, minWidth: "100px" }}>
                          Date Approved
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Uploaded to BT: Yes/No or N/A
                        </th>
                        <th style={{ ...headerStyle, minWidth: "250px" }}>
                          PM Comments
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Uploaded to BT: Yes/No or N/A
                        </th>
                        <th style={{ ...headerStyle, minWidth: "500px" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {section_2_Body('Geo Tech inspection', 'geoTechInspectionDone', 'geoTechInspectionDateApproved', 'geoTechInspectionUploadedToBT_1', 'geoTechInspectionPMCommnets', 'geoTechInspectionUploadedToBT_2', 'geoTechInspection_VPcommercial',)}

                      {section_2_Body('City ground inspection', 'cityGroundInspectionDone', 'cityGroundInspectionDateApproved', 'cityGroundInspectionUploadedToBT_1', 'cityGroundInspectionPMCommnets', 'cityGroundInspectionUploadedToBT_2', 'cityGroundInspection_VPcommercial',)}

                      {section_2_Body('Engineer footing inspection', 'engineerFootingInspectionDone', 'engineerFootingInspectionDateApproved', 'engineerFootingInspectionUploadedToBT_1', 'engineerFootingInspectionPMCommnets', 'engineerFootingInspectionUploadedToBT_2', 'engineerFootingInspection_VPcommercial',)}

                      {section_2_Body('City footing inspection', 'cityFootingInspectionDone', 'cityFootingInspectionDateApproved', 'cityFootingInspectionUploadedToBT_1', 'cityFootingInspectionPMCommnets', 'cityFootingInspectionUploadedToBT_2', 'cityFootingInspection_VPcommercial',)}

                      {section_2_Body('Engineering wall inspection', 'engineeringWallInspectionDone', 'engineeringWallInspectionDateApproved', 'engineeringWallInspectionUploadedToBT_1', 'engineeringWallInspectionPMCommnets', 'engineeringWallInspectionUploadedToBT_2', 'engineeringWallInspection_VPcommercial',)}


                      {section_2_Body('City Wall inspection', 'cityWallInspectionDone', 'cityWallInspectionDateApproved', 'cityWallInspectionUploadedToBT_1', 'cityWallInspectionPMCommnets', 'cityWallInspectionUploadedToBT_2', 'cityWallInspection_VPcommercial',)}

                      {section_2_Body('City storm drain/RWL inspection', 'cityStormDrainRWLinspectionDone', 'cityStormDrainRWLinspectionDateApproved', 'cityStormDrainRWLinspectionUploadedToBT_1', 'cityStormDrainRWLinspectionPMCommnets', 'cityStormDrainRWLinspectionUploadedToBT_2', 'cityStormDrainRWLinspection_VPcommercial',)}

                      {section_2_Body('City sewer connection inspection', 'citySewerConnectionInspectionDone', 'citySewerConnectionInspectionDateApproved', 'citySewerConnectionInspectionUploadedToBT_1', 'citySewerConnectionInspectionPMCommnets', 'citySewerConnectionInspectionUploadedToBT_2', 'citySewerConnectionInspection_VPcommercial',)}

                      {section_2_Body('City plumbing ground rough in inspection', 'cityPlumbingGroundRoughIninspectionDone', 'cityPlumbingGroundRoughIninspectionDateApproved', 'cityPlumbingGroundRoughIninspectionUploadedToBT_1', 'cityPlumbingGroundRoughIninspectionPMCommnets', 'cityPlumbingGroundRoughIninspectionUploadedToBT_2', 'cityPlumbingGroundRoughIninspection_VPcommercial',)}

                      {section_2_Body('City ground seal inspection', 'cityGroundSealInspectionDone', 'cityGroundSealInspectionDateApproved', 'cityGroundSealInspectionUploadedToBT_1', 'cityGroundSealInspectionPMCommnets', 'cityGroundSealInspectionUploadedToBT_2', 'cityGroundSealInspection_VPcommercial',)}

                      {section_2_Body('Engineering framing inspection', 'engineeringFramingInspectionDone', 'engineeringFramingInspectionDateApproved', 'engineeringFramingInspectionUploadedToBT_1', 'engineeringFramingInspectionPMCommnets', 'engineeringFramingInspectionUploadedToBT_2', 'engineeringFramingInspection_VPcommercial',)}

                      {section_2_Body('Vent checklist submitted', 'ventChecklistSubmittedDone', 'ventChecklistSubmittedDateApproved', 'ventChecklistSubmittedUploadedToBT_1', 'ventChecklistSubmittedPMCommnets', 'ventChecklistSubmittedUploadedToBT_2', 'ventChecklistSubmitted_VPcommercial',)}

                      {section_2_Body('Heat/Loss calculation report', 'heatLossCalReportDone', 'heatLossCalReportDateApproved', 'heatLossCalReportUploadedToBT_1', 'heatLossCalReportPMCommnets', 'heatLossCalReportUploadedToBT_2', 'heatLossCalReport_VPcommercial',)}

                      {section_2_Body('City framing inspection', 'cityFramingInspectionDone', 'cityFramingInspectionDateApproved', 'cityFramingInspectionUploadedToBT_1', 'cityFramingInspectionPMCommnets', 'cityFramingInspectionUploadedToBT_2', 'cityFramingInspection_VPcommercial',)}

                      {section_2_Body('City sheeting inspection', 'citySheetingInspectionDone', 'citySheetingInspectionDateApproved', 'citySheetingInspectionUploadedToBT_1', 'citySheetingInspectionPMCommnets', 'citySheetingInspectionUploadedToBT_2', 'citySheetingInspection_VPcommercial',)}

                      {section_2_Body('City Rain screen inspection', 'cityRainScreenInspectionDone', 'cityRainScreenInspectionDateApproved', 'cityRainScreenInspectionUploadedToBT_1', 'cityRainScreenInspectionPMCommnets', 'cityRainScreenInspectionUploadedToBT_2', 'cityRainScreenInspection_VPcommercial',)}

                      {section_2_Body('City Stucco wire inspection', 'cityStuccoWireInspectionDone', 'cityStuccoWireInspectionDateApproved', 'cityStuccoWireInspectionUploadedToBT_1', 'cityStuccoWireInspectionPMCommnets', 'cityStuccoWireInspectionUploadedToBT_2', 'cityStuccoWireInspection_VPcommercial',)}

                      {section_2_Body('City electrical rough inspection', 'cityElectricalRoughInspectionDone', 'cityElectricalRoughInspectionDateApproved', 'cityElectricalRoughInspectionUploadedToBT_1', 'cityElectricalRoughInspectionPMCommnets', 'cityElectricalRoughInspectionUploadedToBT_2', 'cityElectricalRoughInspection_VPcommercial',)}

                      {section_2_Body('City plumbing rough in inspection', 'cityPlumbingRoughInInspectionDone', 'cityPlumbingRoughInInspectionDateApproved', 'cityPlumbingRoughInInspectionUploadedToBT_1', 'cityPlumbingRoughInInspectionPMCommnets', 'cityPlumbingRoughInInspectionUploadedToBT_2', 'cityPlumbingRoughInInspection_VPcommercial',)}

                      {section_2_Body('City insulation inspection', 'cityInsulationInspectionDone', 'cityInsulationInspectionDateApproved', 'cityInsulationInspectionUploadedToBT_1', 'cityInsulationInspectionPMCommnets', 'cityInsulationInspectionUploadedToBT_2', 'cityInsulationInspection_VPcommercial',)}

                      {section_2_Body('Initial blower door test', 'initialBlowerDoorTestDone', 'initialBlowerDoorTestDateApproved', 'initialBlowerDoorTestUploadedToBT_1', 'initialBlowerDoorTestPMCommnets', 'initialBlowerDoorTestUploadedToBT_2', 'initialBlowerDoorTest_VPcommercial',)}

                      {/* {section_2_Body('City insulation inspection', 'cityInsulationInspectionDone', 'cityInsulationInspectionDateApproved', 'cityInsulationInspectionUploadedToBT_1', 'cityInsulationInspectionPMCommnets', 'cityInsulationInspectionUploadedToBT_2', 'cityInsulationInspection_VPcommercial',)} */}

                      {section_2_Body('Aerobarrier/Final blower door test', 'aerobarrierFinalBlowerDoorTestDone', 'aerobarrierFinalBlowerDoorTestDateApproved', 'aerobarrierFinalBlowerDoorTestUploadedToBT_1', 'aerobarrierFinalBlowerDoorTestPMCommnets', 'aerobarrierFinalBlowerDoorTestUploadedToBT_2', 'aerobarrierFinalBlowerDoorTest_VPcommercial',)}

                      {section_2_Body('City final inspection', 'cityFinalInspectionDone', 'cityFinalInspectionDateApproved', 'cityFinalInspectionUploadedToBT_1', 'cityFinalInspectionPMCommnets', 'cityFinalInspectionUploadedToBT_2', 'cityFinalInspection_VPcommercial',)}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 3 */}
              <AccordionTab header="List All LIDA Labour" className="mt-2" >
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "400px" }}>
                          List All LIDA Labour
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated Hours P/W in GR
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated Project Months in GR
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Contract Budget Amount
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Budget Used (time clock)
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Remaining Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Charge out Rate
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Projected Completion Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated Hours to complete P/M
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated # of Months to Compete
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Projected Hours to Complete
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Projected Budget to Compete
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Plus/Minus Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "240px" }}>
                          Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "100px" }}>
                          Add Remove Rows
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {Section3Array.map((item, index) => (

                        <tr>
                          <td style={{ ...cellStyleW }}>{renderTextArea(`section_3[${index}].ListAllLIDALabour`, '', formik.values.section_3[index].ListAllLIDALabour)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputArea(`section_3[${index}].EstimatedHoursGR`, '', '', formik.values.section_3[index].EstimatedHoursGR)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputArea(`section_3[${index}].EstimatedProjectMonthsInGR`, '', '', formik.values.section_3[index].EstimatedProjectMonthsInGR)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputAreaForAmount(`section_3[${index}].ContractBudgetAmount`, formik.values.section_3[index].ContractBudgetAmount)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputAreaForAmount(`section_3[${index}].BudgetUsed`, formik.values.section_3[index].BudgetUsed)}</td>
                          <td style={{ ...cellStyle, textAlign: 'center' }}>
                            {priceBodyTemplatee(formik.values.section_3[index].ContractBudgetAmount - formik.values.section_3[index].BudgetUsed)}
                          </td>
                          <td style={cellStyleW}>{renderInputAreaForAmount(`section_3[${index}].ChargeOutRate`, formik.values.section_3[index].ChargeOutRate)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_3[${index}].ProjectedCompletionDate`, '', 'date', formik.values.section_3[index].ProjectedCompletionDate)}</td>
                          <td style={cellStyleW}>{renderInputAreaForHour(`section_3[${index}].EstimatedHoursToCompletePM`, formik.values.section_3[index].EstimatedHoursToCompletePM)}</td>
                          <td style={cellStyleW}>{renderInputAreaForHour(`section_3[${index}].EstimatedOfMonthsToCompete`, formik.values.section_3[index].EstimatedOfMonthsToCompete)}</td>

                          <td style={{ ...cellStyle, textAlign: 'center' }}> {priceBodyTemplatee(formik.values.section_3[index].EstimatedHoursToCompletePM * formik.values.section_3[index].EstimatedOfMonthsToCompete)} </td>

                          <td style={{ ...cellStyle, textAlign: 'center' }}> {priceBodyTemplatee(formik.values.section_3[index].ChargeOutRate * formik.values.section_3[index].EstimatedHoursToCompletePM * formik.values.section_3[index].EstimatedOfMonthsToCompete)} </td>

                          <td style={{ ...cellStyle, textAlign: 'center' }}>
                            {priceBodyTemplatee((formik.values.section_3[index].ContractBudgetAmount - formik.values.section_3[index].BudgetUsed) - (formik.values.section_3[index].ChargeOutRate * formik.values.section_3[index].EstimatedHoursToCompletePM * formik.values.section_3[index].EstimatedOfMonthsToCompete))}
                          </td>
                          <td style={{ ...cellStyleW }}>{renderTextArea(`section_3[${index}].Comments`, '', formik.values.section_3[index].Comments)}</td>

                          <td style={cellStyleW}>
                           
                          </td>

                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 4 */}
              <AccordionTab header="Gross Profit Per Month" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>

                        <th style={{ ...headerStyle, width: "400px" }}>
                          Actual Contract Duration Months
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          # of Months Slippage Months
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Original Expected GP
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Original GP Months
                        </th>

                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          New Expected GP
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Updated GP/Month
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          GP -/+ Term of Project/Month
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          GP -/+ Term of Project
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          % of GP Slippage
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <td style={cellStyleW}> {renderInputArea(`actualContractDurationMonths`)}</td>
                        <td style={cellStyleW}> {renderInputArea(`monthsOfSlippageMonths`)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`originalExpectedGP`)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`originalGPMonths`)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`newExpectedGP`,)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`updatedGPMonths`,)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`gpTermsOfProjectPerMonths`,)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`gpTermsOfProject`)}</td>
                        <td style={cellStyleW}> {renderPercentageInputArea(`perOfGPSlippage`)}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 5 */}
              <AccordionTab header="LIDA Fees and Reimbursables" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          LIDA Fees and Reimbursables
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Budget Used
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Remaining Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          When to Invoice
                        </th>

                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {section_5_Body('Mark up', '20% contract sign, 20% foundation complete, 20% lock up, 20% rough in complete, 10% drywall complete, 5% cabinets installed, 5% substantial completion - 5% cabinets milestone being billed on next client invoice Feb 15/23', 'markupBudget', 'markupBudgetUsed', 'markupRemainingBudget', 'markupVPCOPSCO', 'markupWhenToInvoice')}


                      {section_5_Body('Overhead', 'Same as above', 'overheadBudget', 'overheadBudgetUsed', 'overheadRemainingBudget', 'overheadVPCOPSCO', 'overheadWhenToInvoice')}


                      {section_5_Body('Delivery Charge', 'Billing on going', 'deliveryChargeBudget', 'deliveryChargeBudgetUsed', 'deliveryChargeRemainingBudget', 'deliveryChargeVPCOPSCO', 'deliveryChargeWhenToInvoice')}

                      {section_5_Body('Equipment & Tool Usage', '50% at first invoice after excavation, 50% lock up', 'equipmentAndToolUsageBudget', 'equipmentAndToolUsageBudgetUsed', 'equipmentAndToolUsageRemainingBudget', 'equipmentAndToolUsageVPCOPSCO', 'equipmentAndToolUsageToInvoice')}

                      {section_5_Body('Liability Insurance', '50% at first invoice after excavation, 50% lock up', 'liabilityInsuranceBudget', 'liabilityInsuranceBudgetUsed', 'liabilityInsuranceRemainingBudget', 'liabilityInsuranceVPCOPSCO', 'liabilityInsuranceWhenToInvoice')}

                      {section_5_Body('Site Safety Management', '50% at first invoice after excavation, 50% lock up', 'siteSafetyManagementBudget', 'siteSafetyManagementBudgetUsed', 'siteSafetyManagementRemainingBudget', 'siteSafetyManagementVPCOPSCO', 'siteSafetyManagementWhenToInvoice')}

                      {section_5_Body('Site Security Storage', '50% at first invoice after excavation, 50% lock up', 'siteSecurityStorageBudget', 'siteSecurityStorageBudgetUsed', 'siteSecurityStorageRemainingBudget', 'siteSecurityStorageVPCOPSCO', 'siteSecurityStorageWhenToInvoice')}


                      {section_5_Body('Temp Fans and Heaters', 'Being billed on next client invoice Feb 15/23', 'tempFansAndHeatersBudget', 'tempFansAndHeatersBudgetUsed', 'tempFansAndHeatersRemainingBudget', 'tempFansAndHeatersVPCOPSCO', 'tempFansAndHeatersWhenToInvoice')}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 6 */}
              <AccordionTab header="MONTHLY CLIENT RATING" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          MONTHLY CLIENT RATING
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          CLIENT RATING 1-10
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          CLIENTS COMMENTS
                        </th>

                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {/* monthlyClientRating */}
                      {PMTemplate.getFormName().section_6.map((item, index) => (
                        // {monthlyClientRating.map((item, index) => (
                        <tr>
                          <td style={{ minWidth: '85px', height: '32px', border: '1px solid white' }}>{PMTemplate.getMonthName(formik.values.section_6[index].monthClientRating)}</td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', textAlign: 'center' }}>{renderSelectForSection5(`section_6.${index}.ClientRating`, 'Please Select Rating', PMTemplate.getRatingList(), formik.values.section_6[index].ClientRating)}</td>

                          <td style={cellStyleW}>
                            {renderTextArea(`section_6.${index}.clientComment`, '', formik.values.section_6[index].clientComment)}
                          </td>
                          <td style={cellStyleW}>
                            {renderTextArea(`section_6.${index}.VpConstructionComment`, '', formik.values.section_6[index].VpConstructionComment)}
                          </td>


                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 7 */}
              <AccordionTab header="BI - WEEKLY PROJECT MANAGER UPDATE" className="mt-2" >
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          BI - WEEKLY PROJECT MANAGER UPDATE
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={cellStyle}>Dear:  {renderTextArea('dear', '???? ???', '')}				</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Here is your weekly summary from:

                          <input
                            type="date"
                            name="hereIsYourWeeklySummaryFrom"
                            id="hereIsYourWeeklySummaryFrom"
                            value={formik.values['hereIsYourWeeklySummaryFrom']}
                            onChange={(e) => formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value)}
                            style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', textAlign: 'center', }}
                          />
                          To :
                          <input
                            type="date"
                            name="hereIsYourWeeklySummaryTo"
                            id="hereIsYourWeeklySummaryTo"
                            value={formik.values['hereIsYourWeeklySummaryTo']}
                            onChange={(e) => formik.setFieldValue('hereIsYourWeeklySummaryTo', e.target.value)}
                            style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', textAlign: 'center', }}
                          />
                        </td>
                      </tr>

                      <tr>
                        <td style={cellStyle}>Project Summary: {renderTextArea('projectSummary', '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Schedule:  Construction Start Date
                          <input
                            type="date"
                            name="scheduleConstructionStartDate"
                            id="scheduleConstructionStartDate"
                            value={formik.values['scheduleConstructionStartDate']}
                            onChange={(e) => formik.setFieldValue('scheduleConstructionStartDate', e.target.value)}
                            readOnly
                            style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', background: "#F8F9FA", textAlign: 'center', }}
                          />
                          Projected Completion
                          <input
                            type="date"
                            name="scheduleProjectCompletion"
                            id="scheduleProjectCompletion"
                            value={formik.values['scheduleProjectCompletion']}
                            onChange={(e) => formik.setFieldValue('scheduleProjectCompletion', e.target.value)}
                            readOnly
                            style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', background: "#F8F9FA", fontSize: '16px', textAlign: 'center', }}
                          />
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 8 */}
              <AccordionTab header="Schedule Milestones" className="mt-2" >
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[1]} >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Schedule Milestones
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Planned Baseline Completion Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Current Forecast Completion Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Actual Completion Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Notes:  If applicable, explain why there was a change fo the schedule
                        </th>
                      </tr>
                    </thead>
                    <tbody>

                      {section_8_Body('Site Prep', 'sitePrep_P_B_C_Date', 'sitePrep_C_F_C_Date', 'sitePrep_A_C_Date', 'sitePrep_Notes', 'sitePrep_VP_C_Comments',)}
                      {section_8_Body('Demolition and Survey', 'demolitionAndSurvey_P_B_C_Date', 'demolitionAndSurvey_C_F_C_Date', 'demolitionAndSurvey_A_C_Date', 'demolitionAndSurvey_Notes', 'demolitionAndSurvey_VP_C_Comments',)}
                      {section_8_Body('Footings and Foundation', 'footingAndFoundation_P_B_C_Date', 'footingAndFoundation_C_F_C_Date', 'footingAndFoundation_A_C_Date', 'footingAndFoundation_Notes', 'footingAndFoundation_VP_C_Comments',)}
                      {section_8_Body('Framing', 'framing_P_B_C_Date', 'framing_C_F_C_Date', 'framing_A_C_Date', 'framing_Notes', 'framing_VP_C_Comments',)}
                      {section_8_Body('Roofing and Mechanical', 'roofingAndMechanical_P_B_C_Date', 'roofingAndMechanical_C_F_C_Date', 'roofingAndMechanical_A_C_Date', 'roofingAndMechanical_Notes', 'roofingAndMechanical_VP_C_Comments',)}
                      {section_8_Body('Exterior Finish', 'exteriorFinish_P_B_C_Date', 'exteriorFinish_C_F_C_Date', 'exteriorFinish_A_C_Date', 'exteriorFinish_Notes', 'exteriorFinish_VP_C_Comments',)}
                      {section_8_Body('Insulation and Drywall', 'insulationAndDrywall_P_B_C_Date', 'insulationAndDrywall_C_F_C_Date', 'insulationAndDrywall_A_C_Date', 'insulationAndDrywall_Notes', 'insulationAndDrywall_VP_C_Comments',)}
                      {section_8_Body('Completion', 'Completion_P_B_C_Date', 'Completion_C_F_C_Date', 'Completion_A_C_Date', 'Completion_Notes', 'Completion_VP_C_Comments',)}
                      {section_8_Body('Turn Over', 'turnOver_P_B_C_Date', 'turnOver_C_F_C_Date', 'turnOver_A_C_Date', 'turnOver_Notes', 'turnOver_VP_C_Comments',)}



                    </tbody>
                  </table>
                </div>
                <div style={{
                textAlign: 'center',
                color: '#495057',
                fontStyle: 'italic',
                marginTop: '10px',
                borderTop: '1px solid #E9ECEF',
                paddingTop: '10px'
              }}>
                A day late is a day stolen from a client's life
              </div>                
              </AccordionTab>

              {/* Section 9*/}
              <AccordionTab header="Activities worked on this week" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[2]} >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Activities worked on this week: (Description)
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Contractor
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Brief Scope of Work
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Current Forecasted Completion Date
                        </th>
                        {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th> */}
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>

                      {Section9Array.map((item, index) => (
                        <tr>

                          <td style={cellStyleW}>{renderTextArea(`section_9.${index}.activitiesworkedOnThisWeek`, '', formik.values.section_9[index].activitiesworkedOnThisWeek)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_9.${index}.Constractor`, '', '', formik.values.section_9[index].Constractor)}</td>
                          <td style={cellStyleW}>
                            {renderTextArea(`section_9.${index}.briefScopeOfWeek`, '', formik.values.section_9[index].briefScopeOfWeek)}
                          </td>
                          <td style={cellStyleW}>{renderInputArea(`section_9.${index}.CurrentForecastedCompletionDate`, '', 'date', formik.values.section_9[index].CurrentForecastedCompletionDate)}</td>

                          <td style={cellStyleW}>
                           
                          </td>

                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 10 */}
              <AccordionTab header="Activities Scheduled for Next Week" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[3]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Activities Scheduled for Next Week: (Description)
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Contractor
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Brief Scope of Work
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Current Forecasted Completion Date
                        </th>

                        {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th> */}
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>

                      {Section10Array.map((item, index) => (
                        <tr>
                          <td style={cellStyleW}>{renderTextArea(`section_10.${index}.activitiesScheduledOnNextWeek`, '', formik.values.section_10[index].activitiesScheduledOnNextWeek)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_10.${index}.Constractor`, '', '', formik.values.section_10[index].Constractor)}</td>
                          <td style={cellStyleW}>
                            {renderTextArea(`section_10.${index}.briefScopeOfWeek`, '', formik.values.section_10[index].briefScopeOfWeek)}
                          </td>
                          <td style={cellStyleW}>{renderInputArea(`section_10.${index}.CurrentForecastedCompletionDate`, '', 'date', formik.values.section_10[index].CurrentForecastedCompletionDate)}</td>

                          <td style={cellStyleW}>
                           
                          </td>

                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 11 */}
              <AccordionTab header="Project Budget" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[4]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Project Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Amount
                        </th>
                        {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th> */}

                      </tr>
                    </thead>
                    <tbody>
                      {section_11_Body('Contract Price', 'contractPriceAmount', 'contractPriceVPCComment')}
                      {section_11_Body('Approved Change Order Price', 'approvedChangeOrderPrice', 'approvedChangeOrderVPCComment')}
                      {section_11_Body('Allowance Difference (Selections to Date)', 'allowanceDiffrence', 'allowanceDiffrenceVPCComment')}
                      {section_11_Body('Job Running Total', 'jobRunningTotal', 'jobRunningTotalVPCComment')}
                      {section_11_Body('GST', 'gst', 'gstVPCComment')}
                      {section_11_Body('Amount Paid ', 'amountPaid', 'amountPaidVPCComment')}
                      {section_11_Body('Balance (Not Including Deposit)', 'balance', 'balanceVPCComment')}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 12 */}
              <AccordionTab header="Project Deposits" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[5]}>
                  <table style={{ borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Project Deposits
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Amount
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {section_11_Body('Contract Deposits', 'contractDepositsAmount', 'contractDepositsVPCComments')}
                      {section_11_Body('Building Permit Deposit', 'buildingPermitDepositAmount', 'buildingPermitDepositVPCComments')}
                      {section_11_Body('Other Deposits', 'otherDepositAmount', 'otherDepositVPCComments')}
                      {section_11_Body('Total Deposits', 'totalDepositAmount', 'totalDepositVPCComments')}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 13 */}
              <AccordionTab header="Change Work Orders" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[6]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Change Work Orders (# and Description)
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Amount
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Approved
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Notes
                        </th>

                        {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th> */}
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {Section13Array.map((item, index) => (
                        <tr>
                          <td style={cellStyleW}>{renderTextArea(`section_13.${index}.changeWorkOrder`, '', formik.values.section_13[index].changeWorkOrder)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_13.${index}.date`, '', 'date', formik.values.section_13[index].date)}</td>
                          <td style={cellStyleW}>{renderInputAreaForAmount(`section_13.${index}.amount`, formik.values.section_13[index].amount)}</td>
                          {/* <td style={cellStyle}>{renderInputArea(`section_13.${index}.amount`, '', '', formik.values.section_13[index].amount)}</td> */}
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
                            {renderSelect1(`section_13.${index}.approved`, formik.values.section_13[index].approved)}
                          </td>

                          <td style={cellStyleW}>
                            {renderTextArea(`section_13.${index}.notes`, '', formik.values.section_13[index].notes)}
                          </td>
                          {/* <td style={cellStyle}>
                            {renderTextArea(`section_13.${index}.VPCComments`, '', formik.values.section_13[index].VPCComments)}
                          </td> */}
                          <td style={cellStyleW}>
                            
                          </td>

                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 14 */}
              <AccordionTab header="Action Items Discussed" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[7]} >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "auto" }}>
                          Action Items Discussed
                        </th>

                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {Section14Array.map((item, index) => (
                        <tr>
                          <td style={cellStyleW}>{renderTextArea(`section_14.${index}.actionItemDiscussed`, '', formik.values.section_14[index].actionItemDiscussed)}</td>


                          <td style={cellStyleW}>
                            

                          </td>

                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 14-B */}
              <AccordionTab header="VP CONSTRUCTION OPS COMMENTS ONLY" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}  >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>

                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          VP CONSTRUCTION OPS COMMENTS ONLY
                        </th>


                      </tr>
                    </thead>
                    <tbody>

                      <tr>

                        <td style={cellStyleW}>
                          {renderTextArea(`vpConstructionCommentsForAll`, '', '', 6)}
                        </td>


                      </tr>


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 15 */}
              {/* <AccordionTab header="JOB AUTOPSY" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>

                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          JOB AUTOPSY
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={cellStyle}>Address:</td>
                        <td style={cellStyleW}>{renderTextArea(`address`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Date of Meeting</td>
                        <td style={cellStyleW}>{renderInputArea(`dateOfMeeting`, '', 'date')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Who is present for Autopsy</td>
                        <td style={cellStyleW}>{renderTextArea(`whoIsPresentForAutopsy`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Project Manager</td>
                        <td style={cellStyleW}>{renderTextArea(`projectManager`, '')}</td>
                      </tr>

                      <tr>
                        <td style={cellStyle}>Interior Designer</td>
                        <td style={cellStyleW}>{renderTextArea(`interiorDesigner`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Foreman</td>
                        <td style={cellStyleW}>{renderTextArea(`foreman`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Project Summary:</td>
                        <td style={cellStyleW}>{renderTextArea(`projectSummary_15`, '')}</td>
                      </tr>


                    </tbody>
                  </table>
                </div>
              </AccordionTab> */}

              {/* ------------------------------------------------------------------------- */}
              {/* Section 16 */}
              <AccordionTab header="OVER ALL PREFORMANCE" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "80vw" }}>
                          OVER ALL PREFORMANCE
                        </th>

                      </tr>
                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Wins:
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`wins`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Losses:
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`losses`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          What did we do well?
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`whatDidWeDoWell`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Where could we make improvements?  Who is accountable to ensure the change is implemented?
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`WhereCouldWeMakeImprovements`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          What trades were excellent and why?  How are we going to recognize our trades for going above and beyond for our clients?
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`WhatTradesWereExcellentAndWhy`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          What trades were a problem and why?  What was done about it?  Who is following up with trade?
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`WhatTradesWereAProblemAndWhy`, '')}
                        </td>
                      </tr>

                    </thead>

                  </table>
                </div>
              </AccordionTab>

              {/* Section 17 */}
              <AccordionTab header="Project Manager & ID Performance Bonus Measurables Per Project" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "600px", }}>
                          Project Manager & ID Performance Bonus Measurables Per Project:  30 points
                        </th>
                        <th style={{ ...headerStyle, minWidth: "150px" }}>
                          PM POINTS
                        </th>
                        <th style={{ ...headerStyle, minWidth: "150px" }}>
                          VP POINTS
                        </th>
                        <th style={{ ...headerStyle, minWidth: "200px" }}>
                          PM/ID COMMENTS
                        </th>
                        <th style={{ ...headerStyle, minWidth: "450px" }}>
                          VP CONSTRUCTION OPS COMMENTS
                        </th>


                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={cellStyle}>

                          <strong>1. TURN OVER DEFICIENCIES:</strong>  Was the final walk through signed off by the client with 5 deficiences?  Was the project book on site, a client orientation conducted, and a gift provided by the LIDA Homes Team?  Was the home ready and clean for Key Day turn over? 1-10 points

                        </td>
                        <td style={cellStyleW}>{renderInputArea('PMPOINTS_1', '', '')}</td>
                        <td style={cellStyleW}>{renderInputArea('VPPOINTS_1', '', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('PMCOMMENTS_1', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('VPCOCOMMENTS_1', '')}</td>

                      </tr>

                      <tr>
                        <td style={cellStyle}>

                          <strong>2.  ERRORS & OMMISSIONS:</strong>   Did LIDA Homes have to write anything off as a result of mistakes by the PM or ID?  Were all of the ID plans correct with accurate measurements.  Loosing the company over $1000 zero points. 1-10 points

                        </td>
                        <td style={cellStyleW}>{renderInputArea('PMPOINTS_2', '', '')}</td>
                        <td style={cellStyleW}>{renderInputArea('VPPOINTS_2', '', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('PMCOMMENTS_2', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('VPCOCOMMENTS_2', '')}</td>

                      </tr>

                      <tr>
                        <td style={cellStyle}>

                          <strong>3.  CLIENT SATISFACTION MONTHLY VP CON OPS CHECK AND NET PROMOTER SCORE:</strong>  What is the overall average score for the BT Client Satisfaction over the term of the project?  1-10 points

                        </td>
                        <td style={cellStyleW}>{renderInputArea('PMPOINTS_3', '', '')}</td>
                        <td style={cellStyleW}>{renderInputArea('VPPOINTS_3', '', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('PMCOMMENTS_3', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('VPCOCOMMENTS_3', '')}</td>

                      </tr>



                      <tr>
                        <td style={cellStyleW}> {renderTextArea('ProjectManager_5', '')}</td>
                        <td style={cellStyleW}>{renderInputArea('PMPOINTS_5', '', '')}</td>
                        <td style={cellStyleW}>{renderInputArea('VPPOINTS_5', '', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('PMCOMMENTS_5', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('VPCOCOMMENTS_5', '')}</td>

                      </tr>

                      <tr>
                        <td style={cellStyleW}> {renderTextArea('ProjectManager_6', '')}</td>
                        <td style={cellStyleW}>{renderInputArea('PMPOINTS_6', '', '')}</td>
                        <td style={cellStyleW}>{renderInputArea('VPPOINTS_6', '', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('PMCOMMENTS_6', '')}</td>
                        <td style={cellStyleW}> {renderTextArea('VPCOCOMMENTS_6', '')}</td>

                      </tr>



                    </tbody>
                  </table>
                </div>
              </AccordionTab>
              
              {/* Section 18 */}
              <AccordionTab header="CONSTRUCTION DETAILS - AWARD INFO" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "80vw" }}>
                          CONSTRUCTION DETAILS - AWARD INFO
                        </th>

                      </tr>
                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Construction Best Pratices (general) - point form:
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`ConstructionBestPratices`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Construction Challenges - point form:
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`ConstructionChallenges`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Energy Performance Document (ensure test results document is availble in the project files in Work File and/or Buildertrend):
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`EnergyPerformanceDocument`, '')}
                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Special Features for Energy Efficiency - point form:
                        </th>
                      </tr>

                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`SelectionOfMaterialsAndResources`, 'Selection of materials and resources (heating systems, high-efficiency materials like lighting, appliances etc):')}

                        </td>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`EnergyAndWaterSavingConsiderations`, 'Energy and water-saving considerations, waste reduction - in the home and during construction:')}

                        </td>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`InnovationAndDesign`, 'Innovation and Design:')}

                        </td>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`SensitivityToSiteConditions`, 'Sensitivity to site conditions and surrounding environments')}

                        </td>
                      </tr>

                      <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>
                          Performanc Targets - Built Green, LEED, Passive House, Net-Zero details (additional to anythng above - point form:
                        </th>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`AnyDetailsNotMentionedAbove`, 'Any details not mentioned above:')}

                        </td>
                      </tr>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextArea(`SalesAndMarketingMaterial`, 'Sales and marketing material to promote energy efficiency:')}


                        </td>
                      </tr>

                    </thead>

                  </table>
                </div>
              </AccordionTab>

            </Accordion>
          </div>
        </form>

      )}

    </>
  );
};

export default VIEW_PM_TEMPLATE;
